import { CONTENT_ALIAS } from './const.config';

export const SEPERATOR = '›';

// Define page-title configurations
const PAGE_TITLE_LIST = {
  OVERVIEW_DASHBOARD: 'Overview Dashboard',
  REALTIME_DASHBOARD: 'Live Users (Per Platform)',
  SUBSCRIBERS: 'Subscribers',
  INVITED_SUBSCRIBERS: 'Invited Subscribers',
  GROUPS: 'Community Groups',
  MANAGE_MEMBERS: 'Manage Members',
  PACKAGES: 'Packages',
  ADMIN_USERS: 'Admin Users',
  CONTENT_CATEGORY: `Content ${SEPERATOR} ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  CONTENT_VIDEOS: `Content ${SEPERATOR} ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_ADS: `Content ${SEPERATOR} Ads`,
  CONTENT_SEQUENCE: `Content ${SEPERATOR} Sequence`,
  CONTENT_SEQUENCE_VIDEOS: `Content ${SEPERATOR} Sequence ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_COMMUNITY_GATHERINGS: `Content ${SEPERATOR} Gatherings`,
  CONTENT_TEACHERS: `Content ${SEPERATOR} Leading Teachers`,
  CONTENT_SEQUENCE_TESTIMONIAL_TABS: `Content ${SEPERATOR} Sequence Testimonial Tabs`,
  CONTENT_SEQUENCE_TESTIMONIAL_CATEGORIES: `Content ${SEPERATOR} Sequence Testimonial Categories`,
  CONTENT_TABS: `Content ${SEPERATOR} Tabs`,
  CONTENT_TESTIMONIALS: `Content ${SEPERATOR} Testimonials`,
  CONTENT_USER_TESTIMONIALS_TEXT: `Content ${SEPERATOR} User Text Testimonials`,
  CONTENT_USER_TESTIMONIALS_VIDEO: `Content ${SEPERATOR} User Video Testimonials`,
  CONTENT_ARTICLE: `Content ${SEPERATOR} Article`,
  CONTENT_SEQUENCE_CATEGORY: `Content ${SEPERATOR} Sequence ${CONTENT_ALIAS.CATEGORY_SINGULAR}`,
  NOTIFICATIONS: 'Notifications',
  SALUTATION: 'Salutation',
  REPORTS_OVERVIEW_VIDEOS: `Analytics Reports ${SEPERATOR} Video Watch Overview`,
  REPORTS_LIVE_USERS: `Analytics Reports ${SEPERATOR} Live Users`,
  REPORTS_SESSIONS: `Analytics Reports ${SEPERATOR} Watch Sessions`,
  REPORTS_SUBSCRIPTIONS: `Analytics Reports ${SEPERATOR} Subscriptions Summary`,
  REPORTS_LIVE_EVENT: `Analytics Reports ${SEPERATOR} Live Event`,
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ERROR_NOT_FOUND: '404 Not Found',
  EVENT_REGISTRATIONS: 'Event Registrations',
  MANAGE_RECURRING_EVENTS: `Manage Recurring Events`,
  CONTENT_RESOURCES_CONTENT: `Content ${SEPERATOR} Resources`,
  CONTENT_RECORDED_MESSAGE: `Content ${SEPERATOR} Recorded`,
  CONTENT_LINK_SECTIONS: `Content ${SEPERATOR} Link Sections`,
  CONTENT_LINK_SECTION_ITEMS: `Content ${SEPERATOR} Link Section Items`,
  QUIZ: 'Quiz',
  QUIZ_MANAGE_QUESTIONS: `Quiz ${SEPERATOR} Manage Questions`,
  QUIZ_RESULTS: `Quiz Results`,
  QUIZ_SUBSCRIBER_RESULTS: `Quiz Subscriber Results`,
  DATA_CHANGE_LOGS: 'Data Changed Logs',
};

export default PAGE_TITLE_LIST;
